import { callLambdaApi, callLambdaApiNoAuth } from "../callLambdaApi";
import { ApiNames, Methods } from "../constants";

export class ResultApiCommunicator {
  create(
    requestBody = {
      name: "SomeResultName",
      modelId: null,
      printNotes: null,
      printRecipient: null,
    }
  ) {
    if (!requestBody.modelId) {
      throw new Error("modelId is required to create a result");
    }
    if (!requestBody.name) {
      throw new Error("name is required to create a result");
    }
    return callLambdaApi({
      method: Methods.POST,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL(),
      payload: {
        body: {
          ...requestBody,
        },
      },
    });
  }

  fetch(token) {
    console.log("fetch()");
    return callLambdaApiNoAuth({
      method: Methods.GET,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/byToken/${token}`,
    });
  }

  /**
   *
   * @param {string} modelId
   * @param {string} printResultId
   * @returns {Promise<{
   * data: {
   * dateAdded: number;
   * downloadUrl: string;
   * gcPrintProjectName: string;
   * manifestMetadata: object;
   * modelId: string;
   * modelName: string;
   * notes: string;
   * orgId: string;
   * printResults: object[];
   * status: "uploaded" | "success" | "processing";
   * userId: string;
   * }
   * }>}
   */
  fetchById(modelId, printResultId) {
    return callLambdaApi({
      method: Methods.GET,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/byId/${modelId}/${printResultId}`,
    });
  }

  update(requestBody) {
    return callLambdaApi({
      method: Methods.PUT,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL(),
      payload: { body: requestBody },
    });
  }

  updateByToken(token, requestBody) {
    return callLambdaApiNoAuth({
      method: Methods.PUT,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/byToken/${token}`,
      payload: { body: requestBody },
    });
  }

  delete(modelId, printResultId) {
    return callLambdaApi({
      method: Methods.DELETE,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/${modelId}/${printResultId}`,
    });
  }

  getScanUploadUrl(token, occurrenceId, fileName) {
    return callLambdaApiNoAuth({
      method: Methods.PUT,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/scan/${token}/${occurrenceId}`,
      payload: { body: {fileName: fileName } },
    });
  }

  /**
   * Returns the default serverless api endpoint
   * using the instance's project and model ids.
   * @private
   */
  _buildBaseURL() {
    return `/print-result`;
  }
}
